module.exports = __webpack_public_path__ + "img/Realisme_Utviklingen_av_det_norske_spraaket1.11f85db3.jpg";